import React from 'react';
import UnreadMessageBadge from './UnreadMessageBadge';
import { useUnreadMessageCount } from '../utils/appBadge';
import {
  CalendarDays,
  CircleUserRound,
  Home,
  MessageSquare,
  Scissors,
  Settings,
  UserRound,
} from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { BRAND_TIFFANY_BLUE } from '../constants/branding';
import { useI18n } from '../i18n';

const BottomNav = () => {
  const location = useLocation();
  const unreadMessageCount = useUnreadMessageCount();
  const navigate = useNavigate();
  const { t } = useI18n();

  const items = [
    {
      label: t('nav.home'),
      icon: Home,
      onClick: () => navigate('/reserve'),
      active: location.pathname === '/reserve' || location.pathname === '/reserve/',
    },
    {
      label: t('nav.booking'),
      icon: CalendarDays,
      onClick: () => navigate('/reserve/booking'),
      active: location.pathname === '/reserve/booking',
    },
    {
      label: t('nav.menu'),
      icon: Scissors,
      onClick: () => navigate('/reserve/menu'),
      active: location.pathname === '/reserve/menu' || location.pathname.startsWith('/reserve/menu/'),
    },
    {
      label: t('nav.staff'),
      icon: UserRound,
      onClick: () => navigate('/reserve/staff'),
      active: location.pathname === '/reserve/staff',
    },
    {
      label: t('nav.myPage'),
      icon: CircleUserRound,
      onClick: () => navigate('/reserve/mypage'),
      active:
        location.pathname === '/reserve/mypage'
        || location.pathname.startsWith('/reserve/history')
        || location.pathname === '/reserve/points'
        || location.pathname === '/reserve/profile',
    },
    {
      label: t('nav.messages'),
      icon: MessageSquare,
      onClick: () => navigate('/messages'),
      active: location.pathname === '/messages',
    },
    {
      label: t('nav.settings'),
      icon: Settings,
      onClick: () => navigate('/settings'),
      active: location.pathname === '/settings',
    },
  ];

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-50 border-t border-white/20 shadow-[0_-8px_24px_rgba(10,186,181,0.18)]"
      style={{
        backgroundColor: BRAND_TIFFANY_BLUE,
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      <div
        className="grid w-full grid-cols-7 gap-1 px-2 pb-2 pt-2"
      >
        {items.map(({ label, icon: Icon, onClick, active }) => (
          <button
            key={label}
            type="button"
            onClick={onClick}
            className={`relative flex min-h-[62px] min-w-0 flex-col items-center justify-center rounded-[18px] px-0.5 py-2.5 text-[8px] font-semibold leading-tight transition ${
              active
                ? 'bg-white text-black shadow-sm'
                : 'text-white/80 hover:bg-white/15 hover:text-white'
            }`}
            aria-current={active ? 'page' : undefined}
          >
            <span className="relative mb-1.5">
              <Icon className="h-[18px] w-[18px]" />
              {Icon === MessageSquare ? <UnreadMessageBadge count={unreadMessageCount} /> : null}
            </span>
            <span>{label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default BottomNav;
